<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <!-- Header da página -->
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Registros de Necessidade</h1>
                                    <p class="modern-subtitle">Visualize registros e itens cadastrados</p>
                                </div>
                                <div class="tabs-row">
                                    <button class="tab-btn"
                                            :class="{ active: activeTab === 'registros' }"
                                            @click="setTab('registros')">
                                        Meus Registros
                                    </button>
                                    <button class="tab-btn d-none"
                                            :class="{ active: activeTab === 'itens' }"
                                            @click="setTab('itens')">
                                        Itens
                                    </button>
                                    <button class="tab-btn"
                                            :class="{ active: activeTab === 'processos' }"
                                            @click="setTab('processos')">
                                        Solicitações de Preenchimento
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="bloqueadoImportacao" class="importacao-em-andamento-container">
                        <div class="importacao-em-andamento-card">
                            <div class="row">
                                <div class="col-12 col-md-2 m-auto">
                                    <div class="importacao-em-andamento-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 3a5 5 0 1 0 4.546 7.083.5.5 0 0 1 .908.418A6 6 0 1 1 8 2v1z" />
                                            <path d="M8 0a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 8 0z" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="col-12 col-md-8 text-start">
                                    <h2>Importação em andamento</h2>
                                    <p class="text-start">{{ mensagemBloqueio }}</p>
                                </div>
                                <div class="col-12 col-md-2  m-auto">
                                    <div class="importacao-em-andamento-actions">
                                        <button class="modern-btn modern-btn-primary" @click="recarregarStatusImportacao" :disabled="carregandoStatusImportacao">
                                            <span v-if="!carregandoStatusImportacao">Recarregar status</span>
                                            <span v-else>Verificando...</span>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="table-container">
                        <div class="table-wrapper">
                            <!-- ===================== ABA REGISTROS ===================== -->
                            <div v-show="activeTab === 'registros'">
                                <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <button @click="abrirModalRegistrarNecessidade" class="modern-btn modern-btn-primary" :disabled="bloqueadoImportacao">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                        </svg>
                                        Novo Registro
                                    </button>
                                    <button @click="abrirModalImportacao" class="modern-btn modern-btn-success" :disabled="bloqueadoImportacao">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                        </svg>
                                        Importar PCA/PNCP
                                    </button>
                                    <div class="left-tools">
                                        <div class="search-box">
                                            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                            <input v-model="regFilter"
                                                   type="text"
                                                   class="modern-search-input"
                                                   placeholder="Buscar por Nome / Descrição" />
                                        </div>
                                    </div>
                                    <button @click="abrirModalImportacaoExcel" class="modern-btn modern-btn-signature" :disabled="bloqueadoImportacao">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                        </svg>
                                        Importar Excel
                                    </button>
                                </div>

                                <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <thead>
                                        <tr>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap;">Nome</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 15%;">Setor</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Itens Utilizados</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Ativo</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Inclusão</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100" style="white-space: nowrap; width: 1%;">Data Desejada</th>
                                            <th class="bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-100 text-center" style="white-space: nowrap; width: 1%;">Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(row, i) in registros"
                                            :key="i"
                                            :class="{ 'row-inativa': !row.flAtivo }">
                                            <td data-label="Nome">
                                                <span class="process-name">{{ row.nmRegistroNecessidade }}</span>
                                            </td>
                                            <td data-label="Setor">
                                                <span class="process-name">{{ nomeSetor(row.idSetor) }}</span>
                                            </td>
                                            <td data-label="Processo Iniciado" class="text-center">
                                                <span :class="['pill', row.qtdItensUtilizados == row.qtdItens  ? 'pill-ok' : 'pill-warn']">
                                                    {{row.qtdItensUtilizados}} de {{row.qtdItens}}
                                                </span>
                                            </td>
                                            <td data-label="Ativo" class="text-center">
                                                <span :class="['pill', row.flAtivo ? 'pill-ok' : 'pill-off']">
                                                    {{ row.flAtivo ? 'Sim' : 'Não' }}
                                                </span>
                                            </td>
                                            <td data-label="Inclusão" class="text-center">{{ formatarData(row.dtInclusao) }}</td>
                                            <td data-label="Data Desejada" class="text-center">
                                                <template v-if="row.dtDesejada">
                                                    {{ formatarData(row.dtDesejada) }}
                                                </template>
                                                <span v-else>-</span>
                                                
                                            </td>
                                            <td data-label="Ações" class="text-center action-cell">
                                                <div class="action-buttons" :class="{ 'actions-disabled': !row.flAtivo }">
                                                    <button @click="abrirDetalhes(row)"
                                                            class="action-btn action-btn-view"
                                                            title="Ver Detalhes"
                                                            :disabled="bloqueadoImportacao">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                        </svg>
                                                        <span class="action-text">Detalhes</span>
                                                    </button>
                                                    <button @click="deletarRegistro(row.idRegistroNecessidade)"
                                                            class="action-btn action-btn-delete"
                                                            title="Excluir Registro"
                                                            :disabled="bloqueadoImportacao">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr v-if="registros.length === 0">
                                            <td colspan="6" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhum registro encontrado</h3>
                                                    <p class="empty-description">Tente ajustar o filtro.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                    <div class="pagination-controls flex items-center">
                                        <span @click="previousPageReg" :class="['page-box', { disabled: regPage === 0 }]">
                                            <span class="navigation-symbol">«</span>
                                        </span>

                                        <span v-for="page in pagesToShowReg"
                                              :key="page"
                                              @click="goToPageReg(page)"
                                              :class="['page-box', page === regPage ? 'btn btn-primary-soft' : '']">
                                            {{ page + 1 }}
                                        </span>

                                        <span @click="nextPageReg" :class="['page-box', { disabled: !temProximaPaginaReg }]">
                                            <span class="navigation-symbol">»</span>
                                        </span>
                                    </div>

                                    <span class="footer-records-text">
                                        Registros encontrados: {{ qtdRegistrosReg }}
                                    </span>
                                </div>
                            </div>

                            <!-- ===================== ABA ITENS ===================== -->
                            <div v-show="activeTab === 'itens'" class="d-none">
                                <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <div class="left-tools">
                                        <div class="filter-select">
                                            <label class="filter-label">Registro:</label>
                                            <select class="form-control form-control-sm" v-model="filtroRegistroId">
                                                <option :value="null">Todos</option>
                                                <option v-for="r in registros" :key="r.idRegistroNecessidade" :value="r.idRegistroNecessidade">
                                                    {{ r.nmRegistroNecessidade }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="search-box">
                                            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                            <input v-model="itemFilter"
                                                   type="text"
                                                   class="modern-search-input"
                                                   placeholder="Buscar por Id Item / Registro" />
                                        </div>
                                    </div>

                                    <div class="right-tools">
                                        <div class="totals">
                                            <span class="total-chip">Itens: <b>{{ itensFiltrados.length }}</b></span>
                                            <span class="total-chip">Qtd total: <b>{{ totalQtdItens }}</b></span>
                                        </div>
                                    </div>
                                </div>

                                <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Item</th>
                                            <th style="white-space: nowrap;">Nome</th>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Qtd Total</th>
                                            <th style="white-space: nowrap; width: 1%;">Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(row, i) in itensFiltrados" :key="row.idItem || i">
                                            <td data-label="Item" class="text-center">
                                                <span class="id-badge">{{ row.cdItem }}</span>
                                            </td>

                                            <td data-label="Nome / Referência">
                                                <div class="item-name">{{ row.nmItem}}</div>
                                                <div class="item-details">
                                                    {{ row.cdReferencia || '-' }}
                                                    <span v-if="row.tpItem">• {{ row.tpItem }}</span>
                                                </div>
                                            </td>

                                            <td data-label="Qtd Total" class="text-center">
                                                <span class="number-badge">{{ formatarQtd(row.qtdTotal) }}</span>
                                            </td>

                                            <td data-label="Ações" class="text-center action-cell">
                                                <div class="action-buttons">
                                                    <button @click="abrirDetalhesItem(row)"
                                                            class="action-btn action-btn-view"
                                                            title="Ver Detalhes">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                        </svg>
                                                        <span class="action-text">Detalhes</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                        <tr v-if="itensFiltrados.length === 0">
                                            <td colspan="7" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhum item encontrado</h3>
                                                    <p class="empty-description">Tente ajustar o filtro ou selecione outro registro.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>

                                <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                    <div class="pagination-controls flex items-center">
                                        <span @click="previousPageItem" :class="['page-box', { disabled: itemPage === 0 }]">
                                            <span class="navigation-symbol">«</span>
                                        </span>

                                        <span v-for="page in pagesToShowItem"
                                              :key="page"
                                              @click="goToPageItem(page)"
                                              :class="['page-box', page === itemPage ? 'btn btn-primary-soft' : '']">
                                            {{ page + 1 }}
                                        </span>

                                        <span @click="nextPageItem" :class="['page-box', { disabled: !temProximaPaginaItem }]">
                                            <span class="navigation-symbol">»</span>
                                        </span>
                                    </div>

                                    <span class="footer-records-text">
                                        Registros encontrados: {{ qtdRegistrosItem }}
                                    </span>
                                </div>
                            </div>
                            <!-- ===================== ABA PROCESSOS ===================== -->
                            <div v-show="activeTab === 'processos'">
                                <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <div class="left-tools">
                                        <div class="filter-select">
                                            <label class="filter-label">Setor:</label>
                                            <select class="form-control form-control-sm" v-model.number="filtroSetorProc">
                                                <option :value="null">Selecione um setor...</option>
                                                <option v-for="s in setores" :key="s.idSetor" :value="s.idSetor">
                                                    {{ s.nmSetor }}
                                                </option>
                                            </select>
                                        </div>

                                        <div class="search-box">
                                            <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                            </svg>
                                            <input v-model="procFilter"
                                                   :disabled="!filtroSetorProc"
                                                   type="text"
                                                   class="modern-search-input"
                                                   placeholder="Buscar por Nome do Registro / ID Processo" />
                                        </div>
                                    </div>
                                </div>
                                <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                    <thead>
                                        <tr>
                                            <th style="white-space: nowrap;">Nome do Registro</th>
                                            <th class="text-center" style="white-space: nowrap; width: 15%;">Processo</th>
                                            <th class="text-center" style="white-space: nowrap; width: 15%;">Proprietário</th>
                                            <th style="white-space: nowrap; width: 7%;">Setor</th>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Inclusão</th>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Prazo</th>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Status</th>
                                            <th class="text-center" style="white-space: nowrap; width: 1%;">Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(row, i) in processosFiltrados" :key="row.idRegistroNecessidade || i">

                                            <td>
                                                <span class="process-name">{{ row.registroNecessidade.nmRegistroNecessidade || '-' }}</span>
                                            </td>

                                            <td class="text-center">
                                                <span class="id-badge">{{ row.registroNecessidade.dsNomeProcesso || '-' }}</span>
                                            </td>

                                            <td class="text-center">
                                                <div class="avatar-wrapper" v-if="row.proprietario" data-bs-toggle="popover" data-bs-placement="top" :data-bs-content="getDataBsProprietario(row.proprietario)">
                                                    <div class="modern-avatar" :style="row.proprietario.urlImgFoto ? '' : 'background:#' + intToRGB(hashCode(row.proprietario.nmUsuario))">
                                                        <img v-if="row.proprietario.urlImgFoto" :src="row.proprietario.urlImgFoto" alt="" />
                                                        <span v-else class="avatar-initials">{{ row.proprietario.nmUsuario.slice(0,2) }}</span>
                                                    </div>
                                                </div>
                                                <span class="id-badge" v-else>{{ row.registroNecessidade.dsLoginProcesso || '-' }}</span>
                                            </td>

                                            <td>
                                                <span class="process-name">{{ nomeSetor(row.registroNecessidade.idSetor) }}</span>
                                            </td>

                                            <td class="text-center">
                                                {{ formatarData(row.registroNecessidade.dtInclusao) }}
                                            </td>

                                            <td class="text-center">
                                                {{ formatarData(row.registroNecessidade.dtLimite) }}
                                            </td>
                                            <td class="text-center" data-label="Status">
                                                <span :class="['pill', statusProcessoPillClass(row.registroNecessidade)]">
                                                    {{ statusProcessoLabel(row.registroNecessidade) }}
                                                </span>
                                            </td>
                                            <td data-label="Ações" class="text-center action-cell">
                                                <div class="action-buttons">
                                                    <button @click="abrirDetalhesProcesso(row)"
                                                            class="action-btn action-btn-view"
                                                            title="Ver Detalhes">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                        </svg>
                                                        <span class="action-text">Detalhes</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="processosFiltrados.length === 0">
                                            <td colspan="7" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhum processo pendente encontrado</h3>
                                                    <p class="empty-description">Tente ajustar o filtro.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                    <div class="pagination-controls flex items-center">
                                        <span @click="previousPageProc" :class="['page-box', { disabled: procPage === 0 }]">
                                            <span class="navigation-symbol">«</span>
                                        </span>

                                        <span v-for="page in pagesToShowProc"
                                              :key="page"
                                              @click="goToPageProc(page)"
                                              :class="['page-box', page === procPage ? 'btn btn-primary-soft' : '']">
                                            {{ page + 1 }}
                                        </span>

                                        <span @click="nextPageProc" :class="['page-box', { disabled: !temProximaPaginaProc }]">
                                            <span class="navigation-symbol">»</span>
                                        </span>
                                    </div>

                                    <span class="footer-records-text">
                                        Registros encontrados: {{ qtdRegistrosProc }}
                                    </span>
                                </div>
                            </div>
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->

        <Modais></Modais>
        <ModalRegistrarNecessidade ref="modalRegistrarNecessidade"
                                   @saved="onRegistroSaved"
                                   @close="onRegistroModalClose" />
        <ModalRegistroItem ref="modalRegistroItem" />
        <ModalProcessoRegistro ref="modalProcessoRegistro"
                               :saveUrl="`${urlApi}/RegistroNecessidade/PostSolicitacaoDoSetor`"
                               @saved="getProcessosPendentes" />

        <ModalImportacaoExcel ref="modalImportacaoExcel"
                                      @import-finished="load" />

        <ModalImportacaoPCA ref="modalImportacaoPCA"
                                      @import-finished="load"/>
    </div><!-- tyn-root -->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import Swal from 'sweetalert2'
    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import ModalRegistrarNecessidade from '@/components/RegistroNecessidade/ModalRegistrarNecessidade.vue'
    import ModalRegistroItem from '@/components/RegistroNecessidade/ModalRegistroItem.vue'
    import ModalProcessoRegistro from '@/components/RegistroNecessidade/ModalProcessoRegistro.vue'
    import ModalImportacaoExcel from '@/components/RegistroNecessidade/ModalImportacaoExcel.vue'
    import ModalImportacaoPCA from '@/components/RegistroNecessidade/ModalImportacaoPCA.vue'

    export default {
        name: 'RegistroNecessidade',
        components: { Header, Modais, ModalRegistrarNecessidade, ModalRegistroItem, ModalProcessoRegistro, ModalImportacaoExcel, ModalImportacaoPCA },

        data() {
            return {
                activeTab: 'registros',

                // REGISTROS
                registros: [],
                regFilter: '',
                regDebounce: null,
                regPage: 0,
                regPageSize: 10,
                qtdRegistrosReg: 0,

                // ITENS
                itens: [],
                itemFilter: '',
                itemDebounce: null,
                itemPage: 0,
                itemPageSize: 10,
                qtdRegistrosItem: 0,

                // PROCESSOS PENDENTES
                processosPendentes: [],
                procFilter: '',
                procDebounce: null,
                procPage: 0,
                procPageSize: 10,
                qtdRegistrosProc: 0,
                filtroSetorProc: null,

                // CONTROLE
                filtroRegistroId: null,
                modalMode: 'create',          // 'create' | 'edit'
                registroEditId: null,
                setores: [],
                urlApi: urlApi,

                //bloqueio importacao
                bloqueadoImportacao: false,
                statusImportacaoAtual: null,
                mensagemBloqueio: '',
                carregandoStatusImportacao: false,
                intervaloStatusImportacao: null,

                importando: false,
            }
        },

        watch: {
            regFilter() {
                clearTimeout(this.regDebounce)
                this.regDebounce = setTimeout(() => {
                    this.regPage = 0
                    this.getRegistros()
                }, 400)
            },

            itemFilter() {
                clearTimeout(this.itemDebounce)
                this.itemDebounce = setTimeout(() => {
                    this.itemPage = 0
                    this.getItens()
                }, 400)
            },

            filtroRegistroId() {
                this.itemPage = 0
                this.getItens()
            },

            procFilter() {
                clearTimeout(this.procDebounce)
                this.procDebounce = setTimeout(() => {
                    this.procPage = 0
                    if (this.filtroSetorProc) this.getProcessosPendentes()
                }, 400)
            },

            filtroSetorProc() {
                this.procPage = 0
                this.getProcessosPendentes()
            },

        },

        methods: {
            load() {
                this.getRegistros();
                this.getUsuarioConfiguracao();

                this.getStatus();
            },

            abrirModalRegistrarNecessidade() {
                this.modalMode = 'create'
                this.registroEditId = null

                if (this.$refs.modalRegistrarNecessidade?.abrir) {
                    this.$refs.modalRegistrarNecessidade.abrir()
                    return
                }

                const el = document.getElementById('ModalRegistrarNecessidade')
                if (!el) return
                const bs = window.bootstrap || window.Bootstrap || null
                if (bs?.Modal) new bs.Modal(el).show()
            },

            onRegistroSaved() {

                this.getRegistros()

                if (this.activeTab === 'itens') {
                    this.getItens()
                }

                if (this.activeTab === 'processos') {
                    this.getProcessosPendentes()
                }

                this.modalMode = 'create'
                this.registroEditId = null
            },


            onRegistroModalClose() {
                this.modalMode = 'create'
                this.registroEditId = null
            },

            abrirDetalhes(row) {
                const id = row?.idRegistroNecessidade
                if (!id) {
                    avisoToast('Registro inválido para abrir detalhes.', 'warning')
                    return
                }

                this.modalMode = 'edit'
                this.registroEditId = id

                const modal = this.$refs.modalRegistrarNecessidade

                if (modal?.abrirParaEdicao) {
                    modal.abrirParaEdicao(id)
                    return
                }

                if (modal?.abrir) {
                    modal.abrir()
                    return
                }

                const el = document.getElementById('ModalRegistrarNecessidade')
                if (!el) return
                const bs = window.bootstrap || window.Bootstrap || null
                if (bs?.Modal) new bs.Modal(el).show()
            },

            abrirDetalhesItem(row) {
                const modal = this.$refs.modalRegistroItem
                if (!modal?.abrir) {
                    avisoToast('Modal de item não disponível.', 'warning')
                    return
                }
                modal.abrir(row)
            },

            setTab(tab) {
                this.activeTab = tab
                if (tab === 'registros' && this.registros.length === 0) this.getRegistros()
                if (tab === 'itens' && this.itens.length === 0) this.getItens()

                if (tab === 'processos') {
                    this.getProcessosPendentes()
                }
            },

            getUsuarioConfiguracao() {
                axios.get(`${urlApi}/UsuarioSetor/GetUsuarioConfiguracao`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data
                            this.setores = Array.isArray(result?.setores) ? result.setores : []
                        } else {
                            console.warn("Resposta sem sucesso")
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err)
                        avisoToast("Erro ao carregar usuario!", "warning")
                    })
            },

            async getRegistros() {
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidade`, {
                        params: {
                            index: this.regPage,
                            take: this.regPageSize,
                            dsTermo: this.regFilter,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar registros!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || []

                    this.registros = rows.map(x => x.registroNecessidade || x)
                    this.qtdRegistrosReg = Number(grid?.qtdRecords || 0)
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar registros!')
                }
            },

            async getItens() {
                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemAgrupado`, {
                        params: {
                            index: this.itemPage,
                            take: this.itemPageSize,
                            idRegistroNecessidade: this.filtroRegistroId || null,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar itens!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || []

                    this.itens = rows.map(x => x.registroNecessidadeItemAgrupado || x)
                    this.qtdRegistrosItem = Number(grid?.qtdRecords || 0)
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar itens!')
                }
            },

            async getProcessosPendentes() {
                this.processosPendentes = []
                this.qtdRegistrosProc = 0

                try {
                    const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadePendente`, {
                        params: {
                            idSetor: this.filtroSetorProc,
                            take: this.procPageSize,
                            index: this.procPage,
                            orderBy: null,
                        }
                    })

                    if (!res.data?.success) {
                        avisoToast(res.data?.msg || 'Erro ao carregar registros pendentes!', 'warning')
                        return
                    }

                    const grid = res.data.data
                    const rows = grid?.rows || []

                    this.processosPendentes = rows;

                    this.qtdRegistrosProc = Number(grid?.qtdRecords || 0)
                    this.montaPopover();
                } catch (err) {
                    console.error(err)
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar registros pendentes!')
                }
            },


            abrirDetalhesProcesso(row) {
                const idReg = row?.registroNecessidade.idRegistroNecessidade
                if (!idReg) {
                    avisoToast('Registro inválido para abrir detalhes.', 'warning')
                    return
                }

                const modal = this.$refs.modalProcessoRegistro
                if (!modal?.abrir) {
                    avisoToast('Modal de processo não disponível.', 'warning')
                    return
                }

                modal.abrir(row)
            },

            deletarRegistro(idRegistroNecessidade) {
                Swal.fire({
                    title: 'Tem certeza?',
                    text: 'Essa ação não poderá ser desfeita!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/RegistroNecessidade/DeleteRegistroNecessidade`, { idRegistroNecessidade })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Registro de Necessidade excluído com sucesso!", "success");
                                    this.getRegistros();
                                } else {
                                    const erroMsg = res.data.msg || "Erro ao excluir registro!";
                                    avisoErro(erroMsg);
                                    avisoToast(erroMsg, "warning");
                                }
                            })
                            .catch(err => {
                                console.error("Erro ao excluir registro:", err);
                                if (err.response && err.response.data) {
                                    avisoErro(err.response.data);
                                    avisoToast("Erro ao excluir registro!", "warning");
                                } else {
                                    avisoErro(err.message || "Erro desconhecido");
                                }
                            });
                    }
                });
            },

            nomeSetor(idSetor) {
                if (!idSetor) return 'Sem Setor'
                return this.setorPorId[idSetor] || `Setor ${idSetor}`
            },

            previousPageReg() {
                if (this.regPage > 0) {
                    this.regPage--
                    this.getRegistros()
                }
            },
            nextPageReg() {
                if (this.temProximaPaginaReg) {
                    this.regPage++
                    this.getRegistros()
                }
            },
            goToPageReg(p) {
                if (p !== this.regPage) {
                    this.regPage = p
                    this.getRegistros()
                }
            },
            previousPageItem() {
                if (this.itemPage > 0) {
                    this.itemPage--
                    this.getItens()
                }
            },
            nextPageItem() {
                if (this.temProximaPaginaItem) {
                    this.itemPage++
                    this.getItens()
                }
            },
            goToPageItem(p) {
                if (p !== this.itemPage) {
                    this.itemPage = p
                    this.getItens()
                }
            },
            previousPageProc() {
                if (this.procPage > 0) {
                    this.procPage--
                    this.getProcessosPendentes()
                }
            },
            nextPageProc() {
                if (this.temProximaPaginaProc) {
                    this.procPage++
                    this.getProcessosPendentes()
                }
            },
            goToPageProc(p) {
                if (p !== this.procPage) {
                    this.procPage = p
                    this.getProcessosPendentes()
                }
            },


            formatarData(dataISO) {
                if (!dataISO) return ''
                const d = new Date(dataISO)
                return d.toLocaleDateString('pt-BR')
            },

            formatarQtd(v) {
                if (v === null || v === undefined) return '0'
                try {
                    return Number(v).toLocaleString('pt-BR')
                } catch {
                    return v
                }
            },
            startOfDay(dateLike) {
                if (!dateLike) return null
                const d = new Date(dateLike)
                if (Number.isNaN(d.getTime())) return null
                d.setHours(0, 0, 0, 0)
                return d
            },

            getStatusProcesso(row) {
                const utilizado = row?.flProcessoIniciado === true
                if (utilizado) return 'completo'

                const hoje = this.startOfDay(new Date())
                const limite = this.startOfDay(row?.dtLimite)

                if (limite && hoje > limite) return 'atrasado'
                return 'pendente'
            },

            statusProcessoLabel(row) {
                const st = this.getStatusProcesso(row)
                if (st === 'completo') return 'Completo'
                if (st === 'atrasado') return 'Atrasado'
                return 'Pendente'
            },

            statusProcessoPillClass(row) {
                const st = this.getStatusProcesso(row)
                if (st === 'completo') return 'pill-ok'
                if (st === 'atrasado') return 'pill-danger'
                return 'pill-primary'
            },
            getDataBsProprietario(item) {
                return ` <span class="mb-0">${item.nmUsuario}</span> `;
            },


            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },

            hashCode(str) {
                if (!str) return 0;
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },

            abrirModalImportacaoExcel() {
                const comp = this.$refs.modalImportacaoExcel;

                if (comp && typeof comp.abrirModal === 'function') {
                    comp.abrirModal(() => {
                        this.load();
                    });
                } else {
                    console.error('Componente ModalImportacaoCatalogoItens não encontrado ou sem método abrirModal.');
                }
            },

            abrirModalImportacao() {
                const comp = this.$refs.modalImportacaoPCA;

                if (comp && typeof comp.abrirModal === 'function') {
                    comp.abrirModal(() => {
                        this.load();
                    });
                } else {
                    console.error('Componente ModalImportacaoPCA não encontrado ou sem método abrirModal.');
                }
            },

            // bloqueio importacao
            iniciarMonitoramentoImportacao() {
                if (this.intervaloStatusImportacao) return;

                this.intervaloStatusImportacao = setInterval(() => {
                    this.getStatus({ silencioso: true });
                }, 10000);
            },

            pararMonitoramentoImportacao() {
                if (!this.intervaloStatusImportacao) return;

                clearInterval(this.intervaloStatusImportacao);
                this.intervaloStatusImportacao = null;
            },

            recarregarStatusImportacao() {
                this.getStatus();
            },

            getStatus(options = {}) {
                const { silencioso = false } = options;
                let $this = this;
                const estavaBloqueado = $this.bloqueadoImportacao;

                if (!silencioso) {
                    $this.carregandoStatusImportacao = true;
                }

                axios.get(`${urlApi}/RegistroNecessidade/GetStatus`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            const itemStatus = result?.itemStatus || null;

                            $this.statusImportacaoAtual = itemStatus;
                            if (!itemStatus) {
                                $this.bloqueadoImportacao = false;
                                $this.mensagemBloqueio = '';
                                $this.pararMonitoramentoImportacao();

                                $this.getRegistros();
                                $this.getUsuarioConfiguracao();
                                return;
                            }
                            const status = (itemStatus.dsStatus || '').trim().toUpperCase();

                            if (status === 'INICIADO') {
                                $this.bloqueadoImportacao = true;
                                $this.mensagemBloqueio = 'Existe uma importação em andamento para este cliente. Aguarde a conclusão para continuar.';
                                $this.itens = [];
                                $this.qtdRegistros = 0;
                                $this.iniciarMonitoramentoImportacao();
                                return;
                            }

                            $this.bloqueadoImportacao = false;
                            $this.mensagemBloqueio = '';
                            $this.pararMonitoramentoImportacao();
                            $this.getRegistros();
                            $this.getUsuarioConfiguracao();

                            if (estavaBloqueado && !silencioso) {
                                if (status === 'FINALIZADO') {
                                    avisoToast('Importação finalizada. A tela foi atualizada.', "success");
                                } else if (status === 'CANCELADO') {
                                    avisoToast('A importação foi cancelada. Dados recarregados.', "warning");
                                }
                            }
                        } else {
                            $this.bloqueadoImportacao = true;
                            $this.mensagemBloqueio = 'Não foi possível validar o status da importação.';
                            $this.iniciarMonitoramentoImportacao();
                            if (!silencioso) {
                                avisoToast("Erro ao validar status da importação!", "warning");
                            }
                        }
                    })
                    .catch(() => {
                        $this.bloqueadoImportacao = true;
                        $this.mensagemBloqueio = 'Erro ao consultar status da importação.';
                        $this.iniciarMonitoramentoImportacao();
                        if (!silencioso) {
                            avisoToast("Erro ao consultar status da importação!", "warning");
                        }
                    })
                    .finally(() => {
                        if (!silencioso) {
                            $this.carregandoStatusImportacao = false;
                        }
                    });
            },

        },

        computed: {

            itensFiltrados() {
                const termo = (this.itemFilter || '').trim().toLowerCase()
                if (!termo) return this.itens

                return this.itens.filter(i => {
                    const a = String(i.idItem ?? '').toLowerCase()
                    const b = String(i.nmItem ?? '').toLowerCase()
                    const c = String(i.cdReferencia ?? '').toLowerCase()
                    const d = String(i.cdItem ?? '').toLowerCase()
                    return a.includes(termo) || b.includes(termo) || c.includes(termo) || d.includes(termo)
                })
            },

            processosFiltrados() {
                const termo = (this.procFilter || '').trim().toLowerCase()
                if (!termo) return this.processosPendentes

                return this.processosPendentes.filter(r => {
                    const nome = String(r.registroNecessidade.nmRegistroNecessidade ?? '').toLowerCase()
                    const idProc = String(r.registroNecessidade.idProcesso ?? '').toLowerCase()
                    const idReg = String(r.registroNecessidade.idRegistroNecessidade ?? '').toLowerCase()
                    return nome.includes(termo) || idProc.includes(termo) || idReg.includes(termo)
                })
            },

            totalPagesProc() {
                return Math.max(1, Math.ceil(this.qtdRegistrosProc / this.procPageSize))
            },
            temProximaPaginaProc() {
                return (this.procPage + 1) < this.totalPagesProc
            },
            pagesToShowProc() {
                const maxPages = 5
                const pages = []
                let start = Math.max(this.procPage - 2, 0)
                let end = Math.min(start + maxPages, this.totalPagesProc)

                if (end - start < maxPages) start = Math.max(end - maxPages, 0)
                for (let i = start; i < end; i++) pages.push(i)
                return pages
            },


            totalQtdItens() {
                const sum = this.itensFiltrados.reduce((acc, x) => acc + (Number(x.qtdTotal) || 0), 0)
                return sum.toLocaleString('pt-BR')
            },

            totalPagesReg() {
                return Math.max(1, Math.ceil(this.qtdRegistrosReg / this.regPageSize))
            },
            temProximaPaginaReg() {
                return (this.regPage + 1) < this.totalPagesReg
            },
            pagesToShowReg() {
                const maxPages = 5
                const pages = []
                let start = Math.max(this.regPage - 2, 0)
                let end = Math.min(start + maxPages, this.totalPagesReg)

                if (end - start < maxPages) start = Math.max(end - maxPages, 0)
                for (let i = start; i < end; i++) pages.push(i)
                return pages
            },

            totalPagesItem() {
                return Math.max(1, Math.ceil(this.qtdRegistrosItem / this.itemPageSize))
            },
            temProximaPaginaItem() {
                return (this.itemPage + 1) < this.totalPagesItem
            },
            pagesToShowItem() {
                const maxPages = 5
                const pages = []
                let start = Math.max(this.itemPage - 2, 0)
                let end = Math.min(start + maxPages, this.totalPagesItem)

                if (end - start < maxPages) start = Math.max(end - maxPages, 0)
                for (let i = start; i < end; i++) pages.push(i)
                return pages
            },
            setorPorId() {
                return (this.setores || []).reduce((acc, s) => {
                    acc[s.idSetor] = s.nmSetor
                    return acc
                }, {})
            },

        },

        mounted() {
            this.load()
        },
        beforeDestroy() {
            this.pararMonitoramentoImportacao();
        },
    }
</script>

<style scoped>
    .row-inativa {
        opacity: 0.55;
        filter: grayscale(0.9);
    }

    [data-bs-theme="dark"] .row-inativa {
        background: rgba(15, 23, 42, 0.35);
    }

        .row-inativa td {
            cursor: default;
        }

    .actions-disabled .action-btn,
    .action-btn:disabled {
        opacity: 0.45;
        pointer-events: none;
        cursor: not-allowed;
    }

        .actions-disabled .action-btn:hover {
            transform: none !important;
            box-shadow: none !important;
        }


    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

        .action-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .action-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-btn-delete {
        background: transparent;
        color: #ef4444;
        border-color: #ef4444;
    }

    [data-bs-theme="dark"] .action-btn-delete {
        color: #f87171;
        border-color: #f87171;
    }

        .action-btn-delete::before {
            background: rgba(239, 68, 68, 0.1);
        }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
            border-color: #ef4444;
        }

    .action-btn:active {
        transform: translateY(0);
    }

    .qtd-cell {
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }

    .qtd-total {
        font-size: 12px;
        opacity: .8;
        white-space: nowrap;
    }

    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

        .modern-header .container {
            max-width: none !important;
        }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 500px;
        min-width: 0;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 42px;
        position: relative;
        overflow: hidden;
    }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .modern-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        .modern-btn:active {
            transform: translateY(0);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

        .modern-btn-primary:disabled {
            opacity: 0.45;
            pointer-events: none;
            cursor: not-allowed;
        }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.25);
    }

        .modern-btn-success:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            box-shadow: 0 8px 20px rgba(16, 185, 129, 0.35);
        }

        .modern-btn-success:disabled {
            opacity: 0.45;
            pointer-events: none;
            cursor: not-allowed;
        }

    .modern-btn-signature {
        background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
        color: white;
        box-shadow: 0 2px 8px rgba(139, 92, 246, 0.25);
    }

        .modern-btn-signature:hover {
            background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
            box-shadow: 0 8px 20px rgba(139, 92, 246, 0.35);
        }

        .modern-btn-signature:disabled {
            opacity: 0.45;
            pointer-events: none;
            cursor: not-allowed;
        }

    /* Abas */
    .tabs-row {
        display: flex;
        gap: 8px;
        margin-top: 16px;
    }

    .tab-btn {
        padding: 10px 20px;
        border: none;
        background: transparent;
        color: #6b7280;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        border-radius: 8px;
        transition: all 0.2s ease;
        position: relative;
    }

        .tab-btn:hover {
            background: rgba(37, 99, 235, 0.08);
            color: #2563eb;
        }

        .tab-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .tab-btn {
        color: #9ca3af;
    }

        [data-bs-theme="dark"] .tab-btn:hover {
            background: rgba(59, 130, 246, 0.15);
            color: #60a5fa;
        }

        [data-bs-theme="dark"] .tab-btn.active {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
        }

    /* Table Container */
    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: 768px) {
        .table-container {
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
    }

    @media (max-width: 768px) {
        .table-wrapper {
            padding: 0 4px;
            min-height: 500px;
        }
    }

    /* Custom Table Header */
    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        flex-wrap: wrap;
    }

    @media (max-width: 768px) {
        .custom-table-header {
            padding: 12px 16px;
            flex-direction: column;
            align-items: stretch;
        }
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .left-tools {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
        min-width: 0;
    }

    .right-tools {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    /* Search Box */
    .search-box {
        position: relative;
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        .search-box {
            width: 100%;
        }
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    @media (max-width: 480px) {
        .search-icon {
            left: 12px;
            width: 16px;
            height: 16px;
        }
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }

    @media (max-width: 480px) {
        .modern-search-input {
            padding: 8px 12px 8px 38px;
            font-size: 13px;
        }
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .modern-search-input:focus {
            background: #111827;
            border-color: #3b82f6;
        }

    [data-bs-theme="dark"] .modern-search-input::placeholder {
        color: #6b7280;
    }

    /* Filter Select */
    .filter-select {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .filter-label {
        font-weight: 600;
        font-size: 13px;
        color: #374151;
        white-space: nowrap;
    }

    [data-bs-theme="dark"] .filter-label {
        color: #e5e7eb;
    }

    .filter-select .form-control {
        min-width: 210px;
        padding: 10px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        background: #f9fafb;
        transition: all 0.3s ease;
    }

        .filter-select .form-control:focus {
            outline: none;
            border-color: #2563eb;
            background: white;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

    [data-bs-theme="dark"] .filter-select .form-control {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .filter-select .form-control:focus {
            background: #111827;
            border-color: #3b82f6;
        }

    /* Totals */
    .totals {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
    }

    .total-chip {
        padding: 8px 14px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #bfdbfe;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #1e40af;
    }

    [data-bs-theme="dark"] .total-chip {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

    /* Custom Table */
    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        .custom-table td {
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 15px;
            color: #374151;
        }

        .custom-table th {
            font-weight: 700;
            font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }

    [data-bs-theme="dark"] .custom-table {
        background: #1f2937;
        border-color: #374151;
    }

        [data-bs-theme="dark"] .custom-table th {
            background: #111827;
            color: #e5e7eb;
            border-bottom-color: #374151;
        }

        [data-bs-theme="dark"] .custom-table td {
            color: #e5e7eb;
            border-bottom-color: #374151;
        }

    .custom-table tbody tr {
        transition: all 0.2s ease;
    }

        .custom-table tbody tr:hover {
            background-color: #f9fafb;
            transform: scale(1.002);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

    [data-bs-theme="dark"] .custom-table tbody tr:hover {
        background-color: #374151;
        color: white;
    }

    /* Badges */
    .id-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 48px;
        padding: 6px 12px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        border-radius: 8px;
        font-weight: 700;
        font-size: 14px;
        border: 2px solid #bfdbfe;
        transition: all 0.2s ease;
    }

        .id-badge:hover {
            transform: scale(1.05);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    [data-bs-theme="dark"] .id-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        color: #93c5fd;
        border-color: #3b82f6;
    }

    .number-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
        color: #374151;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid #d1d5db;
        font-family: 'Courier New', monospace;
        transition: all 0.2s ease;
    }

        .number-badge:hover {
            transform: scale(1.05);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

    [data-bs-theme="dark"] .number-badge {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        color: #e5e7eb;
        border-color: #6b7280;
    }

    .process-name {
        font-weight: 600;
        color: #1f2937;
        font-size: 15px;
        transition: color 0.2s ease;
    }

        .process-name:hover {
            color: #2563eb;
        }

    [data-bs-theme="dark"] .process-name {
        color: #f3f4f6;
    }

        [data-bs-theme="dark"] .process-name:hover {
            color: #93c5fd;
        }

    /* Pills */
    .pill {
        display: inline-flex;
        align-items: center;
        padding: 4px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        line-height: 1;
        border: 1px solid transparent;
    }

    .pill-ok {
        background: rgba(16, 185, 129, .12);
        color: #059669;
        border-color: rgba(16, 185, 129, .25);
    }

    .pill-warn {
        background: rgba(245, 158, 11, .12);
        color: #d97706;
        border-color: rgba(245, 158, 11, .25);
    }

    .pill-off {
        background: rgba(239, 68, 68, .12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, .25);
    }
    .pill-primary {
        background: rgba(13, 110, 253, 0.15);
        color: #0d6efd;
    }

    [data-bs-theme="dark"] .pill-ok {
        background: rgba(16, 185, 129, 0.22);
        color: #34d399;
        border-color: rgba(16, 185, 129, 0.35);
    }

    [data-bs-theme="dark"] .pill-warn {
        background: rgba(245, 158, 11, 0.22);
        color: #fbbf24;
        border-color: rgba(245, 158, 11, 0.35);
    }

    [data-bs-theme="dark"] .pill-off {
        background: rgba(239, 68, 68, 0.22);
        color: #f87171;
        border-color: rgba(239, 68, 68, 0.35);
    }

    [data-bs-theme="dark"] .pill-primary {
        background: rgba(59, 130, 246, 0.22);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .pill-danger {
        background: rgba(239, 68, 68, 0.22);
        color: #f87171;
    }

    .pill-danger {
        background: rgba(220, 53, 69, 0.15);
        color: #dc3545;
    }

    /* Custom Table Footer */
    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        flex-wrap: wrap;
        gap: 12px;
    }

    @media (max-width: 768px) {
        .custom-table-footer {
            padding: 16px;
            flex-direction: column;
            align-items: center;
            font-size: 13px;
            gap: 16px;
        }

            .custom-table-footer > span {
                order: 2;
                text-align: center;
                width: 100%;
                padding: 8px 0;
                background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
                border-radius: 8px;
                color: #374151;
            }

        .pagination-controls {
            order: 1;
            width: 100%;
            max-width: 400px;
        }
    }

    [data-bs-theme="dark"] {
        @media (max-width: 768px) {
            .custom-table-footer > span {
                background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
                color: #e5e7eb;
            }
        }
    }

        [data-bs-theme="dark"] .custom-table-footer {
            background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
            border-color: #374151;
        }

    .footer-records-text {
        font-size: 14px;
        font-weight: 600;
        color: #6b7280;
    }

    [data-bs-theme="dark"] .footer-records-text {
        color: #9ca3af;
    }

    /* Pagination */
    .pagination-controls {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
        justify-content: center;
    }

    @media (max-width: 768px) {
        .pagination-controls {
            gap: 8px;
            padding: 8px 0;
        }
    }

    @media (max-width: 480px) {
        .pagination-controls {
            gap: 6px;
            padding: 4px 0;
        }
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

    @media (max-width: 768px) {
        .page-box {
            width: 40px;
            height: 40px;
            font-size: 14px;
            border-width: 2px;
            font-weight: 700;
            flex-shrink: 0;
        }

            .page-box:hover {
                transform: scale(1.05);
            }

        .navigation-symbol {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        .page-box {
            width: 36px;
            height: 36px;
            font-size: 13px;
            flex-shrink: 0;
        }

            .page-box:hover {
                transform: scale(1.03);
            }

        .navigation-symbol {
            font-size: 18px;
        }
    }

    .page-box:hover {
        background-color: #f3f4f6;
        border-color: #2563eb;
        transform: translateY(-2px);
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
    }

    .page-box.disabled {
        opacity: 0.4;
        pointer-events: none;
        cursor: default;
    }

    .page-box.btn.btn-primary-soft {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
        border-color: #2563eb;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
    }

        .page-box.btn.btn-primary-soft:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            transform: none;
        }

    [data-bs-theme="dark"] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme="dark"] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme="dark"] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    .navigation-symbol {
        display: inline-block;
        line-height: 1;
        font-size: 18px;
        font-weight: 700;
    }

    /* Empty State */
    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    /* Grouped Box (Somatório) */
    .grouped-box {
        margin-top: 24px;
        padding: 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .grouped-box {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .grouped-title {
        font-size: 18px;
        font-weight: 700;
        color: #1f2937;
        margin-bottom: 16px;
    }

    [data-bs-theme="dark"] .grouped-title {
        color: #f9fafb;
    }

    .grouped-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
        gap: 12px;
    }

    .grouped-card {
        padding: 16px;
        background: white;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        text-align: center;
        transition: all 0.2s ease;
    }

        .grouped-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            border-color: #2563eb;
        }

    [data-bs-theme="dark"] .grouped-card {
        background: #1f2937;
        border-color: #374151;
    }

        [data-bs-theme="dark"] .grouped-card:hover {
            border-color: #3b82f6;
        }

    .grouped-id {
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    [data-bs-theme="dark"] .grouped-id {
        color: #9ca3af;
    }

    .grouped-qtd {
        font-size: 20px;
        font-weight: 700;
        color: #2563eb;
        font-family: 'Courier New', monospace;
    }

    [data-bs-theme="dark"] .grouped-qtd {
        color: #60a5fa;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

            .modern-header .container {
                padding-left: 16px;
                padding-right: 16px;
            }

        .header-content {
            flex-direction: column;
            text-align: left;
            gap: 16px;
            padding: 0;
        }

        .title-section {
            width: 100%;
            max-width: 100%;
            margin-left: 0;
            margin-right: 0;
        }

        .modern-title {
            font-size: 24px;
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
        }

        .modern-subtitle {
            font-size: 13px;
            word-wrap: break-word;
            overflow-wrap: break-word;
        }

        .tabs-row {
            width: 100%;
            justify-content: flex-start;
        }

        .tab-btn {
            flex: 1;
            text-align: center;
        }

        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

            .custom-table thead {
                display: none;
            }

            .custom-table tr {
                margin-bottom: 16px;
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
                overflow: hidden;
                border: 1px solid #e5e7eb;
            }

            .custom-table td {
                text-align: left !important;
                padding: 14px 16px;
                position: relative;
                border: none;
                border-bottom: 1px solid #f3f4f6;
            }

                .custom-table td::before {
                    content: attr(data-label);
                    font-weight: 700;
                    display: block;
                    margin-bottom: 6px;
                    color: #4b5563;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .custom-table td:last-child {
                    border-bottom: none;
                    padding: 16px !important;
                    background: #f9fafb;
                }

        .grouped-grid {
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        }
    }

    /* Avatares Modernos */
    .avatar-wrapper {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .modern-avatar {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 3px solid white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
    }

        .modern-avatar:hover {
            transform: scale(1.1) translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .modern-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }


    /* Dark theme para cards responsivos */
    [data-bs-theme="dark"] {
        @media (max-width: 768px) {
            .custom-table tr {
                border-color: #374151;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            }

            .custom-table td {
                border-bottom-color: #374151;
            }

                .custom-table td::before {
                    color: #9ca3af;
                }

                .custom-table td:last-child {
                    background: #1f2937;
                }
        }
    }

    @media (max-width: 480px) {
        .modern-header {
            padding: 16px 0;
        }

        .header-content {
            padding: 0 4px;
        }

        .title-section {
            margin-left: 4px;
            margin-right: 4px;
        }

        .modern-title {
            font-size: 20px;
        }

        .modern-subtitle {
            font-size: 12px;
        }

        .totals {
            flex-direction: column;
            width: 100%;
        }

        .total-chip {
            width: 100%;
            text-align: center;
        }

        .grouped-grid {
            grid-template-columns: 1fr;
        }
    }

    [data-bs-theme="dark"] .modern-avatar {
        border-color: #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    }

    .importacao-em-andamento-container {
        display: flex;
        justify-content: center;
        align-items: center;
        /*min-height: calc(100vh - 260px);*/
        padding: 28px 16px 0px;
    }

    .importacao-em-andamento-card {
        width: 100%;
        max-width: 100%;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(226, 232, 240, 0.95);
        box-shadow: 0 16px 42px rgba(15, 23, 42, 0.08);
        padding: 20px 15px;
        text-align: center;
    }

    .importacao-em-andamento-icon {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin: 0 auto 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
        animation: pulseImportacao 1.8s ease-in-out infinite;
    }

    .importacao-em-andamento-card h2 {
        margin: 0 0 8px;
        font-size: 1.6rem;
        font-weight: 700;
        color: #0f172a;
    }

    .importacao-em-andamento-card p {
        /*margin: 0 auto;*/
        max-width: 620px;
        font-size: 1rem;
        color: #475569;
    }

    .importacao-em-andamento-actions {
        /*margin-top: 20px;*/
        /*margin-bottom: 8px;*/
        display: flex;
        justify-content: center;
    }

    .importacao-em-andamento-card small {
        display: block;
        margin-top: 2px;
        color: #64748b;
        font-size: 0.86rem;
    }

    @keyframes pulseImportacao {
        0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.35);
        }

        70% {
            transform: scale(1.03);
            box-shadow: 0 0 0 14px rgba(37, 99, 235, 0);
        }

        100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
        }
    }

    [data-bs-theme="dark"] .importacao-em-andamento-card {
        background: #0f172a;
        border-color: rgba(51, 65, 85, 0.95);
        box-shadow: 0 16px 42px rgba(2, 6, 23, 0.55);
    }

        [data-bs-theme="dark"] .importacao-em-andamento-card h2 {
            color: #f8fafc;
        }

        [data-bs-theme="dark"] .importacao-em-andamento-card p {
            color: #cbd5e1;
        }

        [data-bs-theme="dark"] .importacao-em-andamento-card small {
            color: #94a3b8;
        }
</style>
